module.exports = __webpack_public_path__ + "static/img/place-view-tabs01.8eeabcf4.svg";